import type { Plugin } from 'vibegame';
import { Border } from './components';
import { BorderSetupSystem, BorderLayoutSystem, BorderCleanupSystem } from './systems';

export const BordersPlugin: Plugin = {
  systems: [BorderSetupSystem, BorderLayoutSystem, BorderCleanupSystem],
  components: { Border },
  config: {
    defaults: {
      border: {
        color: 0xffffff,
        padding: 0,
        thickness: 1.5,
        transition: 1,
      },
    },
  },
};
